import {
  createElementVNode as _createElementVNode,
  openBlock as _openBlock,
  createElementBlock as _createElementBlock,
} from "vue";

export default function render() {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        "data-slot": "icon",
      },
      [
        _createElementVNode("path", {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.7927 3.12012C5.06498 3.12012 3.64236 4.49004 3.64236 6.20675C3.64236 7.52538 4.48318 8.64045 5.65468 9.08563L6.15179 14.3866C6.26204 15.5623 7.13363 16.5229 8.29416 16.7792L14.0681 18.0549C14.2038 19.6472 15.5682 20.8801 17.2073 20.8801C18.935 20.8801 20.3577 19.5102 20.3577 17.7935C20.3577 16.0768 18.935 14.7069 17.2073 14.7069C16.0282 14.7069 14.9947 15.3428 14.4546 16.2913L8.69148 15.0181C8.28888 14.9292 8.00314 14.6014 7.96735 14.2198L7.49807 9.2155C8.89108 8.90266 9.94304 7.68273 9.94304 6.20675C9.94304 4.49004 8.52043 3.12012 6.7927 3.12012ZM5.3684 6.20675C5.3684 5.4582 5.99392 4.82964 6.7927 4.82964C7.59148 4.82964 8.21701 5.4582 8.21701 6.20675C8.21701 6.95529 7.59148 7.58386 6.7927 7.58386C5.99392 7.58386 5.3684 6.95529 5.3684 6.20675ZM15.783 17.7935C15.783 17.0449 16.4085 16.4164 17.2073 16.4164C18.0061 16.4164 18.6316 17.0449 18.6316 17.7935C18.6316 18.542 18.0061 19.1706 17.2073 19.1706C16.4085 19.1706 15.783 18.542 15.783 17.7935Z",
        }),
      ],
    )
  );
}
